import React, { Component, createContext } from 'react';

export const UserActivationContext = createContext({});

export class UserActivationContextProvider extends Component{
    updateLoginUrl = (loginUrlInput) => {
        this.setState({
            loginUrl: loginUrlInput
        })
    }

    state = {
        loginUrl: "",
        updateLoginUrl: this.updateLoginUrl
    }

    render() {
        return (
            <UserActivationContext.Provider value={this.state}>
                {this.props.children}
            </UserActivationContext.Provider>
        )
    }
}